import { graphql } from "./generated/gql";

export const MyGoogleAccountsQuery = graphql(`
  query MyGoogleAccounts {
    myGoogleAccounts {
      nodes {
        employeeInterviewInterviewerGoogleAccountId
        employeeInterviewInterviewerId
        googleEmail
        calendarId
        label
        isActive
        createdAt
        updatedAt
      }
      maxAccounts
    }
  }
`);

export const MyGoogleAuthStatusQuery = graphql(`
  query MyGoogleAuthStatus {
    myGoogleAuthStatus {
      connected
      googleEmail
    }
  }
`);

export const InitMainGoogleAuthMutation = graphql(`
  mutation InitMainGoogleAuth($input: InitGoogleAuthInput!) {
    initMainGoogleAuth(input: $input) {
      authUrl
    }
  }
`);

export const CompleteMainGoogleAuthMutation = graphql(`
  mutation CompleteMainGoogleAuth($input: CompleteMainGoogleAuthInput!) {
    completeMainGoogleAuth(input: $input) {
      connected
      googleEmail
    }
  }
`);

export const InitAdditionalGoogleAccountMutation = graphql(`
  mutation InitAdditionalGoogleAccount($input: InitGoogleAuthInput!) {
    initAdditionalGoogleAccount(input: $input) {
      authUrl
      currentCount
      maxCount
    }
  }
`);

export const AddGoogleAccountMutation = graphql(`
  mutation AddGoogleAccount($input: AddGoogleAccountInput!) {
    addGoogleAccount(input: $input) {
      employeeInterviewInterviewerGoogleAccountId
      employeeInterviewInterviewerId
      googleEmail
      calendarId
      label
      isActive
      createdAt
      updatedAt
    }
  }
`);

export const UpdateGoogleAccountMutation = graphql(`
  mutation UpdateGoogleAccount($input: UpdateGoogleAccountInput!) {
    updateGoogleAccount(input: $input) {
      employeeInterviewInterviewerGoogleAccountId
      isActive
      label
    }
  }
`);

export const DeleteGoogleAccountMutation = graphql(`
  mutation DeleteGoogleAccount($id: String!) {
    deleteGoogleAccount(employeeInterviewInterviewerGoogleAccountId: $id)
  }
`);
